
<template>
  <Loader v-if="loader" />

  <div class="card">
      <div class="formgrid grid ">
          <div class="field col-12 md:col-5">
              <label>Anno</label>
              <Calendar v-model="dates" :showIcon="true" view="year" dateFormat="yy" selectionMode="multiple" :class="['inputfield w-full',{'p-invalid': validationErrors.date && submitted}]" />
              <div v-show="validationErrors.date && submitted" class="p-error">Seleziona data.</div>
          </div>
          <div class="field col-12 md:col-5">
              <label>Agente</label>
              <Dropdown v-model="selectedAgent" :options="agents" optionLabel="name" optionValue="id" dataKey="id" :filter="true" placeholder="Seleziona Agente" class="w-full" />              
          </div>
          <div class="field col-12 md:col-2 flex align-items-end justify-content-center">
              <Button label="Cerca" icon="pi pi-search" iconPos="left" class="w-full" @click="searchData" />
          </div>
      </div>
      <!-- <div class="mb-3" v-if="yearsComparision.length > 1">
        <Accordion>
          <AccordionTab header="Confronta">
            <p class="m-2">Compara {{moment(dates).format('YYYY')}} con :</p>
            <Button @click="compareYears(item.year)" v-for="item in yearsComparision" :key="item.year" type="button" :label="item.year.toString()" class="btn-year m-2" />
          </AccordionTab>
        </Accordion>
      </div> -->
  </div>

  

  <div class="card infociclo" v-for="(item, year) in items" :key="year">

    <h2>{{year}}</h2>

    <!-- <div>{{item}}</div> -->

      <DataTable ref="dt" :value="item" :filters="filters" responsiveLayout="scroll">
          <template #header>
            <div class="flex justify-content-between flex-wrap">
                <div class="flex align-items-center justify-content-center mb-2">
                </div>
                <div class="flex align-items-center justify-content-center">
                   <Button icon="pi pi-external-link" label="Esporta" @click="exportCSV($event)" class="p-button-secondary" />
                </div>
            </div>
          </template>
          
          <template #empty>
              <div class="text-center">Nessun dato trovato.</div>
          </template>
          <ColumnGroup type="header">
            <Row>
                <Column header="" :colspan="1" style="min-width:140px;" />
                <Column class="th-power" header="POWER" :colspan="12" />
                <Column class="th-gas" header="GAS" :colspan="11" />
                <Column class="th-totali" header="TOTALI" :colspan="10" />
            </Row>
             <Row>
                <Column field="date" header="Mese"/>

                <Column field="numero_fatture_ee" class="border-lt th-power" header="N. Fatture"  :sortable="true"/>
                <Column field="pdf_attivi_ee" class="border-lt th-power" header="Pdf Attivi" :sortable="true" />
                <Column field="energia_ee" class="border-lt th-power" header="Energia" :sortable="true" />
                <Column field="imponibile_ee" class="border-lt th-power" header="Imponibile" :sortable="true" />
                <Column field="totale_ee" class="border-lt th-power" header="Totale" :sortable="true" />
                <Column field="pagato_ee" class="border-lt th-power" header="Pagato" :sortable="true" />
                <Column field="saldo_ee" class="border-lt th-power" header="Saldo" :sortable="true" />
                <Column field="media_ee" class="border-lt th-power" header="Media" :sortable="true" />
                <Column field="imposte_ee" class="border-lt th-power" header="Accise" :sortable="true" />
                <Column field="iva_ee" class="border-lt th-power" header="Iva" :sortable="true" />
                <Column field="depositi_cauzionali_ee" class="border-lt th-power" header="Dep. Cauzionali" :sortable="true" />
                <Column field="canone_rai" class="border-lt th-power" header="Canone Rai" :sortable="true" />

                <Column field="numero_fatture_gas" class="border-lt th-gas" header="N. Fatture"  :sortable="true"/>
                <Column field="pdf_attivi_gas" class="border-lt th-gas" header="Pdf Attivi" :sortable="true" />
                <Column field="energia_gas" class="border-lt th-gas" header="Energia" :sortable="true" />
                <Column field="imponibile_gas" class="border-lt th-gas" header="Imponibile" :sortable="true" />
                <Column field="totale_gas" class="border-lt th-gas" header="Totale" :sortable="true" />
                <Column field="pagato_gas" class="border-lt th-gas" header="Pagato" :sortable="true" />
                <Column field="saldo_gas" class="border-lt th-gas" header="Saldo" :sortable="true" />
                <Column field="media_gas" class="border-lt th-gas" header="Media" :sortable="true" />
                <Column field="imposte_gas" class="border-lt th-gas" header="Accise" :sortable="true" />
                <Column field="iva_gas" class="border-lt th-gas" header="Iva" :sortable="true" />
                <Column field="depositi_cauzionali_gas" class="border-lt th-gas" header="Dep. Cauzionali" :sortable="true" />

                <Column class="border-lt th-totali" header="N. Fatture" />
                <Column class="border-lt th-totali" header="Pdf Attivi" />
                <Column class="border-lt th-totali" header="Imponibile" />
                <Column class="border-lt th-totali" header="Totale" />
                <Column class="border-lt th-totali" header="Pagato" />
                <Column class="border-lt th-totali" header="Saldo" />
                <Column class="border-lt th-totali" header="Media" />
                <Column class="border-lt th-totali" header="Accise" />
                <Column class="border-lt th-totali" header="Iva" />
                <Column class="border-lt th-totali" header="Dep. Cauzionali" />
            </Row>
          </ColumnGroup>


           <Column  field="date" class="sticky-cell">
            <template #body="{data}">
              {{getMonthFormat(data.date)}}     
            </template>
          </Column>

          <Column field="numero_fatture_ee"  class="border-lt">
            <template #body="{data}">
              {{data.numero_fatture_ee}}     
            </template>
          </Column>
         <Column field="pdf_attivi_ee" class="border-lt" >
            <template #body="{data}">
              {{data.pdf_attivi_ee}}     
            </template>
          </Column>
          <Column field="energia_ee" class="border-lt" >
            <template #body="{data}">
              {{data.energia_ee}}     
            </template>
          </Column>
          <Column field="imponibile_ee" class="border-lt" >
            <template #body="{data}">
              {{formatCurrency(data.imponibile_ee)}}     
            </template>
          </Column>
          <Column field="totale_ee" class="border-lt" >
            <template #body="{data}">
              {{formatCurrency(data.totale_ee)}}     
            </template>
          </Column>
         <Column field="pagato_ee" class="border-lt" >
            <template #body="{data}">
              {{formatCurrency(data.pagato_ee)}}     
            </template>
          </Column>
          <Column field="saldo_ee" class="border-lt" >
            <template #body="{data}">
              {{formatCurrency(data.saldo_ee)}}     
            </template>
          </Column>
          <Column field="media_ee" class="border-lt" >
            <template #body="{data}">
              {{formatCurrency(data.media_ee)}}     
            </template>
          </Column>
         <Column field="imposte_ee" class="border-lt" >
            <template #body="{data}">
              {{formatCurrency(data.imposte_ee)}}     
            </template>
          </Column>
          <Column field="iva_ee" class="border-lt" >
            <template #body="{data}">
              {{formatCurrency(data.iva_ee)}}     
            </template>
          </Column>
          <Column field="depositi_cauzionali_ee" class="border-lt" >
            <template #body="{data}">
              {{formatCurrency(data.depositi_cauzionali_ee)}}     
            </template>
          </Column>
          <Column field="canone_rai" class="border-lt" >
            <template #body="{data}">
              {{formatCurrency(data.canone_rai)}}     
            </template>
          </Column>



         <Column field="numero_fatture_gas" class="border-lt">
            <template #body="{data}">
              {{data.numero_fatture_gas}}     
            </template>
          </Column>
          <Column field="pdf_attivi_gas" class="border-lt" >
            <template #body="{data}">
              {{data.pdf_attivi_gas}}     
            </template>
          </Column>
          <Column field="energia_gas" class="border-lt" >
            <template #body="{data}">
              {{data.energia_gas}}     
            </template>
          </Column>
          <Column field="imponibile_gas" class="border-lt" >
            <template #body="{data}">
              {{formatCurrency(data.imponibile_gas)}}     
            </template>
          </Column>
          <Column field="totale_gas" class="border-lt" >
            <template #body="{data}">
              {{formatCurrency(data.totale_gas)}}     
            </template>
          </Column>
          <Column field="pagato_gas" class="border-lt" >
            <template #body="{data}">
              {{formatCurrency(data.pagato_gas)}}     
            </template>
          </Column>
          <Column field="saldo_gas" class="border-lt" >
            <template #body="{data}">
              {{formatCurrency(data.saldo_gas)}}     
            </template>
          </Column>
          <Column field="media_gas" class="border-lt" >
            <template #body="{data}">
              {{formatCurrency(data.media_gas)}}     
            </template>
          </Column>
          <Column field="imposte_gas" class="border-lt" >
            <template #body="{data}">
              {{formatCurrency(data.imposte_gas)}}     
            </template>
          </Column>
          <Column field="iva_gas" class="border-lt" >
            <template #body="{data}">
              {{formatCurrency(data.iva_gas)}}     
            </template>
          </Column>
          <Column field="depositi_cauzionali_gas" class="border-lt" >
            <template #body="{data}">
              {{formatCurrency(data.depositi_cauzionali_gas)}}     
            </template>
          </Column>


          <Column class="border-lt">
            <template #body="{data}">
              {{data.numero_fatture_ee + data.numero_fatture_gas }}     
            </template>
          </Column>
          <Column class="border-lt" >
            <template #body="{data}">
              {{data.pdf_attivi_ee + data.pdf_attivi_gas}}     
            </template>
          </Column>
          <Column class="border-lt" >
            <template #body="{data}">
              {{formatCurrency(data.imponibile_ee + data.imponibile_gas)}}     
            </template>
          </Column>
          <Column class="border-lt" >
            <template #body="{data}">
              {{formatCurrency(data.totale_ee + data.totale_gas)}}     
            </template>
          </Column>
          <Column class="border-lt" >
            <template #body="{data}">
              {{formatCurrency(data.pagato_ee + data.pagato_gas)}}     
            </template>
          </Column>
          <Column class="border-lt" >
            <template #body="{data}">
              {{formatCurrency(data.saldo_ee + data.saldo_gas)}}     
            </template>
          </Column>
          <Column class="border-lt" >
            <template #body="{data}">
              {{formatCurrency(data.media_ee + data.media_gas)}}     
            </template>
          </Column>
          <Column class="border-lt" >
            <template #body="{data}">
              {{formatCurrency(data.imposte_ee + data.imposte_gas)}}     
            </template>
          </Column>
          <Column class="border-lt" >
            <template #body="{data}">
              {{formatCurrency(data.iva_ee + data.iva_gas)}}     
            </template>
          </Column>
          <Column class="border-lt" >
            <template #body="{data}">
              {{formatCurrency(data.depositi_cauzionali_ee + data.depositi_cauzionali_gas)}}     
            </template>
          </Column>
          
          <ColumnGroup type="footer">
            <Row>
                 <Column :colspan="1" class="td-footer" footer="Totali"/>
                 <Column :colspan="1" class="td-footer" :footer="totale_n_fatture_ee(year)" />
                 <Column :colspan="1" class="td-footer" :footer="totale_n_pdf_ee(year)" />
                 <Column :colspan="1" class="td-footer" :footer="totale_energia_ee(year)" />
                 <Column :colspan="1" class="td-footer" :footer="totale_imponibile_ee(year)" />
                 <Column :colspan="1" class="td-footer" :footer="totale_fatture_ee(year)" />
                 <Column :colspan="1" class="td-footer" :footer="totale_pagato_ee(year)" />
                 <Column :colspan="1" class="td-footer" :footer="totale_saldo_ee(year)" />
                 <Column :colspan="1" class="td-footer" :footer="totale_media_ee(year)" />
                 <Column :colspan="1" class="td-footer" :footer="totale_imposte_ee(year)" />
                 <Column :colspan="1" class="td-footer" :footer="totale_iva_ee(year)" />
                 <Column :colspan="1" class="td-footer" :footer="totale_cauzioni_ee(year)" />
                 <Column :colspan="1" class="td-footer" :footer="totale_rai_ee(year)" />

                <Column :colspan="1" class="td-footer" :footer="totale_n_fatture_gas(year)" />
                 <Column :colspan="1" class="td-footer" :footer="totale_n_pdf_gas(year)" />
               <Column :colspan="1" class="td-footer" :footer="totale_energia_gas(year)" />
                   <Column :colspan="1" class="td-footer" :footer="totale_imponibile_gas(year)" />
                 <Column :colspan="1" class="td-footer" :footer="totale_fatture_gas(year)" />
                   <Column :colspan="1" class="td-footer" :footer="totale_pagato_gas(year)" />
                 <Column :colspan="1" class="td-footer" :footer="totale_saldo_gas(year)" />
                 <Column :colspan="1" class="td-footer" :footer="totale_media_gas(year)" />
                 <Column :colspan="1" class="td-footer" :footer="totale_imposte_gas(year)" />
                 <Column :colspan="1" class="td-footer" :footer="totale_iva_gas(year)" />
                 <Column :colspan="1" class="td-footer" :footer="totale_cauzioni_gas(year)" />

                 <Column :colspan="1" class="td-footer" :footer="totale_n_fatture_ee_gas(year)" />
                 <Column :colspan="1" class="td-footer" :footer="totale_n_pdf_ee_gas(year)" />
                 <Column :colspan="1" class="td-footer" :footer="totale_imponibile_ee_gas(year)" />
                 <Column :colspan="1" class="td-footer" :footer="totale_fatture_ee_gas(year)" />
                 <Column :colspan="1" class="td-footer" :footer="totale_pagato_ee_gas(year)" />
                 <Column :colspan="1" class="td-footer" :footer="totale_saldo_ee_gas(year)" />
                 <Column :colspan="1" class="td-footer" :footer="totale_media_ee_gas(year)" />
                 <Column :colspan="1" class="td-footer" :footer="totale_imposte_ee_gas(year)" />
                 <Column :colspan="1" class="td-footer" :footer="totale_iva_ee_gas(year)" />
                 <Column :colspan="1" class="td-footer" :footer="totale_cauzioni_ee_gas(year)" /> 
            </Row>
          </ColumnGroup>
          
      </DataTable>
  </div>
  

</template>

<script>
import moment from 'moment'
import Service from '@/services/ask-pratiche/pratiche-dashboard'
import UtilityService from '@/services/ask-management/utility-service'
import { ref, onMounted, getCurrentInstance  } from 'vue';
import { FilterMatchMode } from 'primevue/api';
import Loader from '@/components/Loader.vue'


export default {
    components: {
      Loader
    },
    setup() {

      const dt = ref();
      const loader = ref(false)
      const filters = ref({
          'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
      });
      const self = getCurrentInstance();
      self.$eventBus = self.appContext.config.globalProperties.$eventBus
      self.$http = self.appContext.config.globalProperties.$http
      const formatDate = self.appContext.config.globalProperties.$formatDate
      const service = new Service(self.$http, self.$eventBus)
      const utilityService = new UtilityService(self.$http, self.$eventBus)
      const items = ref([]);
      const originalItems = ref([]);
      const agents = ref()
      const selectedAgent = ref(-1)
      // const yearsComparision = ref([]);
      const dates = ref([]/*moment(new Date()).format('YYYY')*/);
      const validationErrors = ref({})
      const submitted = ref(false)


      onMounted(() =>{
        getAgenti()
      })

  
      const getAgenti = () => {
        loader.value = true
        utilityService.getAgenti()
        .then((res) =>{
          res.items.unshift({
            id: -1,
            name: 'Nessuno'
          })
          agents.value = res.items
        })
        .finally(()=>{
          loader.value = false
        })
      }

      const searchData = async () => {
        submitted.value = true;
        if (validateData()) {
          let dates_selected = dates.value.map(date => moment(date).year());
          loader.value = true
          service.getInfoCiclo(selectedAgent.value, dates_selected).then((res) => {
            items.value = res.items.info
            originalItems.value = res.items.info
            // yearsComparision.value = res.items.years.filter(el => el.year != moment(dates.value).format('YYYY'))
          }).finally(() => {
            loader.value = false
          })
        }
      }


      // const compareYears = (year) => {
      //   loader.value = true
      //   service.getInfoCiclo(selectedAgent.value, year).then((res) => {
      //     let itemsToCompare = res.items.info;
      //     let newArray = []
      //     originalItems.value.forEach((el, i) => {
      //       newArray.push(el)
      //       newArray.push(itemsToCompare[i])
      //     });
      //     items.value = newArray
      //   }).finally(() => {
      //     loader.value = false
      //   })
      // }



      const totale_n_fatture_ee = (year) => {
          let total = 0;
          for(let el of items.value[year]) {
              total += el.numero_fatture_ee;
          }
          return total;
      };

      const totale_n_pdf_ee = (year) => {
          let total = 0;
          for(let el of items.value[year]) {
              total += el.pdf_attivi_ee;
          }
          return total;
      };

      const totale_energia_ee = (year) => {
          let total = 0;
          for(let el of items.value[year]) {
              total += el.energia_ee;
          }
          return total;
      };

      const totale_imponibile_ee = (year) => {
          let total = 0;
          for(let el of items.value[year]) {
              total += el.imponibile_ee;
          }
          return formatCurrency(total);
      };

      const totale_fatture_ee = (year) => {
          let total = 0;
          for(let el of items.value[year]) {
              total += el.totale_ee;
          }
          return formatCurrency(total);
      };

      const totale_pagato_ee = (year) => {
          let total = 0;
          for(let el of items.value[year]) {
              total += el.pagato_ee;
          }
          return formatCurrency(total);
      };

      const totale_saldo_ee = (year) => {
          let total = 0;
          for(let el of items.value[year]) {
              total += el.saldo_ee;
          }
          return formatCurrency(total);
      };

      const totale_media_ee = (year) => {
          let total = 0;
          for(let el of items.value[year]) {
              total += el.media_ee;
          }
          return formatCurrency(total);
      };

      const totale_imposte_ee = (year) => {
          let total = 0;
          for(let el of items.value[year]) {
              total += el.imposte_ee;
          }
          return formatCurrency(total);
      };

      const totale_iva_ee = (year) => {
          let total = 0;
          for(let el of items.value[year]) {
              total += el.iva_ee;
          }
          return formatCurrency(total);
      };

      const totale_cauzioni_ee = (year) => {
          let total = 0;
          for(let el of items.value[year]) {
              total += el.depositi_cauzionali_ee;
          }
          return formatCurrency(total);
      };

      const totale_rai_ee = (year) => {
          let total = 0;
          for(let el of items.value[year]) {
              total += el.canone_rai;
          }
          return formatCurrency(total);
      };


      const totale_n_fatture_gas = (year) => {
          let total = 0;
          for(let el of items.value[year]) {
              total += el.numero_fatture_gas;
          }
          return total;
      };

      const totale_n_pdf_gas = (year) => {
          let total = 0;
          for(let el of items.value[year]) {
              total += el.pdf_attivi_gas;
          }
          return total;
      };

       const totale_energia_gas = (year) => {
          let total = 0;
          for(let el of items.value[year]) {
              total += el.energia_gas;
          }
          return total;
      };

      const totale_imponibile_gas = (year) => {
          let total = 0;
          for(let el of items.value[year]) {
              total += el.imponibile_gas;
          }
          return formatCurrency(total);
      };

      const totale_fatture_gas = (year) => {
          let total = 0;
          for(let el of items.value[year]) {
              total += el.totale_gas;
          }
          return formatCurrency(total);
      };

      const totale_pagato_gas = (year) => {
          let total = 0;
          for(let el of items.value[year]) {
              total += el.pagato_gas;
          }
          return formatCurrency(total);
      };

      const totale_saldo_gas = (year) => {
          let total = 0;
          for(let el of items.value[year]) {
              total += el.saldo_gas;
          }
          return formatCurrency(total);
      };

      const totale_media_gas = (year) => {
          let total = 0;
          for(let el of items.value[year]) {
              total += el.media_gas;
          }
          return formatCurrency(total);
      };

      const totale_imposte_gas = (year) => {
          let total = 0;
          for(let el of items.value[year]) {
              total += el.imposte_gas;
          }
          return formatCurrency(total);
      };

      const totale_iva_gas = (year) => {
          let total = 0;
          for(let el of items.value[year]) {
              total += el.iva_gas;
          }
          return formatCurrency(total);
      };

      const totale_cauzioni_gas = (year) => {
          let total = 0;
          for(let el of items.value[year]) {
              total += el.depositi_cauzionali_gas;
          }
          return formatCurrency(total);
      };

      const totale_n_fatture_ee_gas = (year) => {
          let total = 0;
          for(let el of items.value[year]) {
              total += el.numero_fatture_ee + el.numero_fatture_gas;
          }
          return total;
      };

      const totale_n_pdf_ee_gas = (year) => {
          let total = 0;
          for(let el of items.value[year]) {
              total += el.pdf_attivi_ee + el.pdf_attivi_gas;
          }
          return total;
      };

      const totale_imponibile_ee_gas = (year) => {
          let total = 0;
          for(let el of items.value[year]) {
              total += el.imponibile_ee + el.imponibile_gas;
          }
          return formatCurrency(total);
      };

      const totale_fatture_ee_gas = (year) => {
          let total = 0;
          for(let el of items.value[year]) {
              total += el.totale_ee + el.totale_gas;
          }
          return formatCurrency(total);
      };

      const totale_pagato_ee_gas = (year) => {
          let total = 0;
          for(let el of items.value[year]) {
              total += el.pagato_ee + el.pagato_gas;
          }
          return formatCurrency(total);
      };

      const totale_saldo_ee_gas = (year) => {
          let total = 0;
          for(let el of items.value[year]) {
              total += el.saldo_ee + el.saldo_gas;
          }
          return formatCurrency(total);
      };

      const totale_media_ee_gas = (year) => {
          let total = 0;
          for(let el of items.value[year]) {
              total += el.media_ee + el.media_gas;
          }
          return formatCurrency(total);
      };

      const totale_imposte_ee_gas = (year) => {
          let total = 0;
          for(let el of items.value[year]) {
              total += el.imposte_ee + el.imposte_gas;
          }
          return formatCurrency(total);
      };

      const totale_iva_ee_gas = (year) => {
          let total = 0;
          for(let el of items.value[year]) {
              total += el.iva_ee + el.iva_gas;
          }
          return formatCurrency(total);
      };

      const totale_cauzioni_ee_gas = (year) => {
          let total = 0;
          for(let el of items.value[year]) {
              total += el.depositi_cauzionali_ee + el.depositi_cauzionali_gas;
          }
          return formatCurrency(total);
      };


      
      const formatCurrency = (value) => {
        return value.toLocaleString('it-IT', {style: 'currency', currency: 'EUR'});
      };

      
      const getMonthFormat = (date) => {
        return moment(new Date(date)).locale('it').format('MMMM YYYY').toUpperCase()
      }

      const exportCSV = () => {
        dt.value.exportCSV();
      };

      const validateData = () =>{
          if (dates.value == null)
            validationErrors.value['date'] = true;
          else 
            delete validationErrors.value['date'];
    
        return !Object.keys(validationErrors.value).length;
      }



      return { 
        dt,
        moment,
        items,
        loader, 
        filters, 
        dates,
        searchData,
        // compareYears,
        agents,
        selectedAgent,
        exportCSV,
        validationErrors,
        submitted,
        formatDate,
        formatCurrency,
        getMonthFormat,
        totale_n_fatture_ee,
        totale_n_pdf_ee,
        totale_energia_ee,
        totale_fatture_ee,
        totale_imponibile_ee,
        totale_pagato_ee,
        totale_saldo_ee,
        totale_media_ee,
        totale_imposte_ee,
        totale_iva_ee,
        totale_cauzioni_ee,
        totale_rai_ee,
        totale_n_fatture_gas,
        totale_n_pdf_gas,
        totale_energia_gas,
        totale_fatture_gas,
        totale_imponibile_gas,
        totale_pagato_gas,
        totale_saldo_gas,
        totale_media_gas,
        totale_imposte_gas,
        totale_iva_gas,
        totale_cauzioni_gas,
        totale_n_fatture_ee_gas,
        totale_n_pdf_ee_gas,
        totale_fatture_ee_gas,
        totale_imponibile_ee_gas,
        totale_pagato_ee_gas,
        totale_saldo_ee_gas,
        totale_media_ee_gas,
        totale_imposte_ee_gas,
        totale_iva_ee_gas,
        totale_cauzioni_ee_gas,
        // yearsComparision,
        // onDateChange
      }
  }
}
</script>



<style>
.infociclo .p-datatable .p-datatable-thead > tr > th.th-power {
  background: rgba(251, 230, 138, 0.742) !important;
  min-width: 120px;
}

.infociclo .p-datatable .p-datatable-thead > tr > th.th-gas {
  background: rgba(137, 185, 244, 0.412) !important;  
  min-width: 120px;
}

.infociclo .p-datatable .p-datatable-tbody > tr > td.border-lt, .p-datatable .p-datatable-thead > tr > th.border-lt {
  border-left: 1px solid rgba(62, 62, 62, 0.093);
}
.infociclo .p-datatable .p-datatable-tfoot > tr > td.td-footer {
 color: #0a8cf5 !important;
 font-size: 15px;
}
.infociclo .p-datatable .p-datatable-tbody > tr > td.sticky-cell {
  position: sticky !important;
  left: 0 !important;
  background-color: rgb(249, 249, 249);
}


</style>
<style scoped>
.btn-year {
  min-width: 100px;
}
</style>
